<loader-modal *ngIf="isLoading$ | async"></loader-modal>

<ng-container *ngIf="currentScope$ | async as currentScope">
  <div class="flex flex-col h-full">
    <scope-overview-header
      [scope]="currentScope"
      [changeRequest]="currentChangeRequest$ | async" />

    <description-editor
      class="scope-description px-10"
      *ngIf="currentScope"
      [(visible)]="editScopeDescription"
      [model]="currentScope"
      [editable]="scopeApprovalFlowService.isScopeEditable(currentScope)"
      (onSaveDescription)="saveScopeDescription($event, currentScope)"
      (onSaveNote)="saveScopeNote($event, currentScope)" />

    <details-overview
      class="pt-2"
      *ngIf="currentScope"
      [scopeVersion]="currentScope"
      [changeRequests]="changeRequests$ | async"
      [currentChangeRequest]="currentChangeRequest$ | async"
      [scopeRetainedHoursStats]="scopeRetainedHoursStats$ | async"
      [sowRetainedHoursStats]="sowRetainedHoursStats$ | async"
      [trafficMetadataLookupFields]="userSettingsService.getTrafficMetadataFields(this.loggedInUser)"
      [thirdPartyCostBalance]="thirdPartyCostBalance$ | async"
      [scenario]="scenario$ | async"
      [exchangeRates]="exchangeRates"
      (onVersionChange)="setScopeVersion(currentScope.identity.id, $event)"
      (onChangeRequestChange)="setChangeRequest($event)" />

    <scope-overview-content
      [currentScope]="currentScope"
      [changeRequests]="changeRequests$ | async"
      [currentChangeRequest]="currentChangeRequest$ | async" />
  </div>
</ng-container>
